import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem, FormGroup} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {CSVLink} from "react-csv"
import {useEffect, useState} from "react"
import { fetchHotels, fetchDest, fetchdestHotelsbyDest } from "../api/customerapi";
//import { getHotels } from "../actions/customer";
import GetRole from "./user";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(20),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign:"left"
    },
}));

const Listhoteldata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
{ field: 'hotel_id', 
  headerName: ' Hotel ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  { field: 'hotel_name', 
  headerName: ' Hotel Name', 
  width: width/12*2.5,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'hotel_city',
    headerName: 'City',
    width: width/12*2,
    
  },
  {
    field: 'rezlive_id',
    headerName: 'Rezlive ID',
    width: width/12,
    
  },
  {
    field: 'hotel_price_range',
    headerName: 'Price Range',
    width: width/12*1.5,
  },
  {
    field: 'star_category',
    headerName: 'Star Category',
    width: width/12*1.5,
  },
  {
    field: 'hotel_usp',
    headerName: 'USP',
    width: width/12*3.5,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
  
];

const headers=[
  {label:"Hotel Id", key:"hotel_id"},
  {label:"Name", key:"hotel_name"},
  {label:"Destination", key:"hotel_destination"},
  {label:"City", key:"hotel_city"},
  {label:"Star Category", key:"star_category"},
  {label:"TripAdvisor Link", key:"hotel_tripadvisor_link"},
  
]


var { cuser, role } = GetRole();
const [dest, setdest]=useState([])
const [alldest, setalldest]=useState([])
    const [cities, setcities]=useState([])
const [leadfilterData, setleadfilterData]=useState({})
const [listhotelData, setlisthotelData]=useState([{
    hotel_name: "",
    hotel_city:"",
    hotel_destination: "",
    
    hotel_tripadvisor_link: "",
    city_center_area: "",
    
    hotel_usp: "",
}]);
  
const loadhotel = async () => {
  try{
    setleadfilterData({...leadfilterData,cities:""})
  if(leadfilterData.destination=="" || leadfilterData.destination==null || leadfilterData.destination=="All" ) {
  const data = await fetchHotels();
  //console.log(data);
  //const custdatalistfromdb= data.data
  setlisthotelData(data.data)
  }else{
    const data = await fetchdestHotelsbyDest(leadfilterData.destination);
    const temp=alldest.filter(d=>d.dest[0]==leadfilterData.destination)
    //console.log(temp[0].cities)
  setcities(temp[0].cities)
  setlisthotelData(data.data)

  }
}catch(err){
  console.log(err)
}
}

const getDest = async () => {
  try{
  const data = await fetchDest();
  const temp=data.data.filter(d=>"order" in d)
  setalldest(data.data)
  setdest(temp[0].dest);
}catch(err){
  console.log(err)
}
}

useEffect(() => {
  getDest()
  
}, [])

  var hotellist=[...listhotelData]

  if(leadfilterData.on_the_beach){
    hotellist=hotellist.filter(h=>h.tag_onthebeach)
  }
  if(leadfilterData.near_beach){
    hotellist=hotellist.filter(h=>h.tag_nearbeach)
  }
  if(leadfilterData.ocean_view){
    hotellist=hotellist.filter(h=>h.tag_oceanview)
  }
  if(leadfilterData.riverfront){
    hotellist=hotellist.filter(h=>h.tag_riverfront)
  }
  if(leadfilterData.private_pool){
    hotellist=hotellist.filter(h=>h.tag_privatepool)
  }
  if(leadfilterData.cottage){
    hotellist=hotellist.filter(h=>h.tag_cottage)
  }
  if(leadfilterData.mountain_view){
    hotellist=hotellist.filter(h=>h.tag_mountainview)
  }
  if(leadfilterData.bathtub){
    hotellist=hotellist.filter(h=>h.tag_bathtub)
  }
  if(leadfilterData.kitchen){
    hotellist=hotellist.filter(h=>h.tag_kitchen)
  }
  if(leadfilterData.family_room){
    hotellist=hotellist.filter(h=>h.tag_family_room)
  }
  if(leadfilterData.cities){
    hotellist=hotellist.filter(h=>h.hotel_city==leadfilterData.cities)
  }
  if(leadfilterData.reco){
    hotellist=hotellist.filter(h=>h.hotel_reco==leadfilterData.reco)
  }


  const hoteldatalistdisplay=hotellist.map(hoteldata=>({hotel_name: hoteldata.hotel_name, 
    hotel_id: hoteldata.hotel_id,
    id:listhotelData.indexOf(hoteldata), 
    hotel_city:hoteldata.hotel_city, 
    rezlive_id:hoteldata.rezlive_id,
    hotel_price_range:hoteldata.hotel_price_range, 
    star_category:hoteldata.star_category, 
    hotel_usp:hoteldata.hotel_benefit,
    hotel_tripadvisor_link:hoteldata.hotel_tripadvisor_link,
  }));
    //console.log(hoteldatalistfromdb);

  const gridcellclick=(id)=>{
    window.open("/hoteldataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  }

    return ( 
      <div>
      {dest.length>0 ?(
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Hotels</Typography>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
                    
                    
                
                </Select>
                </FormControl>
                
                {cities.length>0?(
                  <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Cities">Cities</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Cities" value={leadfilterData.cities} onChange={(e)=> setleadfilterData({...leadfilterData, cities: e.target.value})}>
                <MenuItem value="">Clear</MenuItem>
                {cities.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
              </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Priority">Priority</InputLabel>
                <Select className={classes.textField} labelId="Priority" InputLabelProps={{ shrink: true }} value={leadfilterData.reco} onChange={(e)=> setleadfilterData({...leadfilterData, reco: e.target.value})}>
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={"Highly Recommended"}>Highly Recommended</MenuItem>
                    <MenuItem value={"Recommended"}>Recommended</MenuItem>
                    <MenuItem value={"Not Recommended"}>Not Recommended</MenuItem>
                    <MenuItem value={"Not Allowed"}>Not Allowed</MenuItem>
                    
                </Select>
                </FormControl> 
                </FormGroup>
                ):("")}
        <Button onClick={loadhotel} variant="contained"  color="inherit" className={classes.button}>Load</Button>
        {role=="Admin" || role=="Manager" || role=="Product"?(<Button href="/hoteldataentry" variant="contained" color="primary" className={classes.button}>Add Hotel</Button>):("")}
        {hoteldatalistdisplay.length>0?(<div>
          <FormGroup row className={classes.formgroup}>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="On_the_beach">On the beach</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="On_the_beach"  onChange={(e)=> setleadfilterData({...leadfilterData, on_the_beach: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>          
                    
                    
                
                </Select>
                </FormControl>
                
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="Near_beach">Near beach</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Near_beach" value={leadfilterData.near_beach} onChange={(e)=> setleadfilterData({...leadfilterData, near_beach: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="Ocean_view">Ocean view</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Ocean_view" value={leadfilterData.ocean_view} onChange={(e)=> setleadfilterData({...leadfilterData, ocean_view: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="riverfront">Riverfront</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="riverfront" value={leadfilterData.riverfront} onChange={(e)=> setleadfilterData({...leadfilterData, riverfront: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>    
                    
                
                </Select>
                </FormControl>
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="Private_Pool">Private Pool</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Private_Pool" value={leadfilterData.private_pool} onChange={(e)=> setleadfilterData({...leadfilterData, private_pool: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>      
                    
                
                </Select>
                </FormControl>
                
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="cottage">Cottage</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="cottage" value={leadfilterData.cottage} onChange={(e)=> setleadfilterData({...leadfilterData, cottage: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="Mountain_view">Mountain view</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Mountain_view" value={leadfilterData.mountain_view} onChange={(e)=> setleadfilterData({...leadfilterData, mountain_view: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="bathtub">Bathtub</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="bathtub" value={leadfilterData.bathtub} onChange={(e)=> setleadfilterData({...leadfilterData, bathtub: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="kitchen">Kitchen</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="kitchen" value={leadfilterData.kitchen} onChange={(e)=> setleadfilterData({...leadfilterData, kitchen: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 8, marginLeft: 8}}>
            <InputLabel id="family_room">Family Room</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="family_room" value={leadfilterData.family_room} onChange={(e)=> setleadfilterData({...leadfilterData, family_room: e.target.value})}>
                
                <MenuItem value={""}>Clear</MenuItem>  
                <MenuItem value={"Yes"}>Yes</MenuItem>     
                    
                
                </Select>
                </FormControl>
          </FormGroup>
        </div>):("")}
        <Button href="/searchhotel" variant="contained"  color="secondary" className={classes.button}>Search Hotels</Button>
        
        </div>
        {hoteldatalistdisplay.length>1?(<div>
                   <CSVLink data={hoteldatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={hoteldatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.hotel_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
    ):("Loading...")}
    </div>
     )
}
 
export default Listhoteldata;